/* oxlint-disable typescript/no-explicit-any */
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles/index.css';

export interface IIconLoader extends React.HTMLProps<SVGSVGElement> {
  style?: object;
  className?: string;
  size?: number;
  active?: boolean;
}

export function IconSync({ active, className, ...restProps }: IIconLoader) {
  return (
    // oxlint-disable-next-line react/forbid-elements
    <svg
      {...restProps}
      className={cx([className, active && styles.sync])}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 16a8.008 8.008 0 0 1-8-8h2.134A5.866 5.866 0 1 0 8 2.133V0a8 8 0 1 1 0 16z"
      />
    </svg>
  );
}
